// extracted by mini-css-extract-plugin
module.exports = {"countries":"SectionCountries_countries__Zh_O2","container":"SectionCountries_container__5FZVc","countries__heading":"SectionCountries_countries__heading__KaCKf"};